
import React from 'react'
import { CheckCircle2, AlertCircle } from 'lucide-react'
import { UploadResult } from './types/uploadTypes'

interface UploadResultsProps {
  results: UploadResult[]
}

const UploadResults = ({ results }: UploadResultsProps) => {
  if (results.length === 0) return null
  
  return (
    <div className="mt-6 space-y-4">
      <h3 className="font-medium">Upload Results</h3>
      <div className="max-h-60 overflow-y-auto space-y-2">
        {results.map((result, index) => (
          <div 
            key={index}
            className={`flex items-center gap-2 p-2 rounded ${
              result.status === 'success' 
                ? 'bg-green-50 text-green-700' 
                : 'bg-red-50 text-red-700'
            }`}
          >
            {result.status === 'success' ? (
              <CheckCircle2 className="h-4 w-4" />
            ) : (
              <AlertCircle className="h-4 w-4" />
            )}
            <span className="flex-1">{result.email}</span>
            {result.error && (
              <span className="text-sm text-red-600">{result.error}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default UploadResults
